import { c as _c } from "react/compiler-runtime";
import type { ISectorPage } from '@/interfaces';
import { BrowserHttpClient } from '@/services/Http/BrowserHttpClient';
import { logger } from '@/utils/logger/logger';
import type { Country } from 'bnef';
import { useEffect, useState } from 'react';
export interface RelatedContentResults {
  relatedCountries?: Country[];
  relatedSectors?: ISectorPage[];
}
export const useSearchRelatedContent = (searchQuery, t0) => {
  const $ = _c(8);
  const debounceMs = t0 === undefined ? 300 : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [relatedContent, setRelatedContent] = useState(t1);
  const [isLoading, setIsLoading] = useState(false);
  let t2;
  let t3;
  if ($[1] !== debounceMs || $[2] !== searchQuery) {
    t2 = () => {
      const abortController = new AbortController();
      const fetchRelatedContent = async () => {
        if (!searchQuery || searchQuery.trim().length < 2) {
          setRelatedContent({});
          setIsLoading(false);
          return;
        }
        setIsLoading(true);
        ;
        try {
          const response = await new BrowserHttpClient(abortController.signal).get({
            path: "/related_search",
            query: {
              q: searchQuery
            }
          });
          if (!abortController.signal.aborted) {
            setRelatedContent(response);
            setIsLoading(false);
          }
        } catch (t4) {
          const err = t4;
          logger.error("Error fetching related content for search:", err);
          if (!abortController.signal.aborted) {
            setRelatedContent({});
            setIsLoading(false);
          }
        }
      };
      const timeoutId = setTimeout(fetchRelatedContent, debounceMs);
      return () => {
        clearTimeout(timeoutId);
        abortController.abort();
      };
    };
    t3 = [searchQuery, debounceMs];
    $[1] = debounceMs;
    $[2] = searchQuery;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== isLoading || $[6] !== relatedContent) {
    t4 = {
      relatedContent,
      isLoading
    };
    $[5] = isLoading;
    $[6] = relatedContent;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};